export default __webpack_public_path__ + "static/media/White0007.664cb627.png";